import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { ConfirmationModal, TextField, Typography, useOverlayContext } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { getPMDetails } from '~/integrations/PracticeManagement/pm.utils';
import styles from './APIKeyModal.module.scss';
const APIKeyModal = (param)=>{
    let { pmName, apiKeyListener, dismissModal } = param;
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { t: commonTexts } = useLocaleKeys('common');
    const [apiKey, setApiKey] = useState('');
    const overlayContext = useOverlayContext();
    const handleChange = (e)=>{
        setApiKey(e.target.value);
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'a_p_i_key_cancel'
            }
        },
        title: sharedTexts.setApiKey(),
        testId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-modal"),
        textAlignCenter: false,
        width: "640px",
        content: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    children: [
                        "To integrate with ".concat(getPMDetails(pmName).name, ", copy your API key from the Anchor integration page in your ").concat(getPMDetails(pmName).name, " account and paste it into the field below. "),
                        /*#__PURE__*/ _jsx(ExternalLinkButton, {
                            href: getPMDetails(pmName).articleLink,
                            testId: 'learn-more-link',
                            openInNewTab: true,
                            bi: {
                                name: 'pm_api_key_learn_more'
                            },
                            children: "Learn more"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.textfield,
                    children: /*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'integration_api_key'
                        },
                        collapseHelperText: false,
                        onChange: handleChange,
                        testId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-input")
                    })
                })
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.set(),
        onPrimaryButtonClick: async ()=>{
            overlayContext.startLoader('SetAPIKey');
            const { success } = await handleRequest(apiKeyListener.saveApiKey(apiKey));
            overlayContext.stopLoader('SetAPIKey');
            if (!success) {
                overlayContext.showErrorToast(commonTexts.toasts.failedToSetApiKey(), "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-failed"));
            } else {
                dismissModal();
            }
        },
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onSecondaryButtonClick: ()=>dismissModal(),
        primaryButtonTestId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-submit"),
        secondaryButtonTestId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-cancel")
    });
};
export default APIKeyModal;
